<template>
  <q-layout view="lHh Lpr lFf">
    <!-- <q-header elevated>
      <q-toolbar>
        <q-toolbar-title>{{ $t('app.language') }}</q-toolbar-title>
        <q-space />
        <q-select
          dense
          outlined
          square
          v-model="currentLocale"
          :options="langOptions"
          emit-value
          map-options
          hide-dropdown-icon
          style="width: 180px"
        />
      </q-toolbar>
    </q-header> -->

    <q-page-container >
      <router-view />
      <!-- <span>{{ token }}</span> -->
    </q-page-container>
  </q-layout>
</template>

<script>
import Inicio from "./components/Inicio/MainPage.vue"
import axios from 'axios'
import { colors } from 'quasar'
import { setLanguage } from './i18n'

export default {
  name: 'LayoutDefault',

  components: {
    Inicio
  },

  data() {
    return {
      leftDrawerOpen: false,
      currentLocale: this.$i18n ? this.$i18n.locale : 'es'
    }
  },
  created() {
    this.$store.dispatch("autoLogin");
    this.GetEmpresa();
    // colors.setBrand('primary', '#33F')
  },
  computed: {
    token() {
      return this.$store.state.usuario;
    },
    langOptions() {
      return [
        { label: this.$t('app.spanish'), value: 'es' },
        { label: this.$t('app.english'), value: 'en' }
      ]
    },
    rutaAxios() {
            return this.$store.state.rutaMongoStore
        }
  },
  watch: {
    currentLocale(newLocale) {
      setLanguage(newLocale)
      // In Quasar v1, language change requires page reload
      this.$q.notify({
        message: this.$t('app.languageChanged'),
        caption: this.$t('app.reloadRequired'),
        color: 'info',
        actions: [
          {
            label: this.$t('buttons.reload'),
            color: 'white',
            handler: () => window.location.reload()
          }
        ]
      })
    }
  },
  methods: {
    async GetEmpresa() {
      try {
        let response = await axios.get('Empresa/GetEmpresa/erp_' + this.token.rfc + '/' + this.token.rfc);
        console.log(response)
        this.$store.state.empresaStore = response.data

        console.log(this.$store.state.empresaStore)
      } catch (error) {

        this.$store.state.empresaStore = {
          _id: '',
          rfc: '',
          nombre: '',
          regimenFiscal: {
            regimenFiscal: ''
          },
          domicilioFiscal: '',
          logo: {
            base64: '',
          },
          nombreCorreo: '',
          correo: '',
          password: '',
          puerto: '',
          host: '',
        }
      }
    },
  }
}
</script>
<style>
 body {
  background: #f4f5f7 !important;
}
 
</style>